import gsap from 'gsap'

import {
  fadeRevealAnimation,
  getScrollTriggerOptions,
  type SharedAnimation
} from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const footerRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const newsletter = selector('[data-motion-newsletter]')[0]
  const footer = selector('[data-motion-footer]')[0]

  let newsletterAnimation: SharedAnimation
  if (newsletter) {
    newsletterAnimation = fadeRevealAnimation(newsletter)
    const newsletterTimeline = gsap.timeline({
      ...getScrollTriggerOptions(newsletter, reverse),
      delay
    })
    newsletterTimeline.add(newsletterAnimation.timeline, 0)
  }

  let footerAnimation: SharedAnimation
  if (footer) {
    footerAnimation = fadeRevealAnimation(footer)
    const footerTimeline = gsap.timeline({
      ...getScrollTriggerOptions(footer, reverse),
      delay
    })
    footerTimeline.add(footerAnimation.timeline, 0)
  }

  return () => {
    newsletterAnimation?.revert()
    footerAnimation?.revert()
  }
}
